// extracted by mini-css-extract-plugin
export var lg = "_dl-7";
export var md = "_dl-6";
export var placeholderContainer = "_dl-1";
export var placeholderIcon = "_dl-2";
export var productImage = "_dl-0";
export var sm = "_dl-5";
export var xl = "_dl-8";
export var xs = "_dl-4";
export var xxs = "_dl-3";